import dayjs from 'dayjs';

export const API = {
  bookings: {
    path: '/bookings?populate[id_yacht][populate][id_attendance][populate][id_agent_NA][populate][id_users_permissions_user]=%2A&populate[id_yacht][populate][id_attendance][populate][id_agent_NA][fields][0]=id_users_permissions_user&populate[id_marina]=%2A&populate[id_reservation]=%2A&populate[id_yacht][populate][id_attendance][populate][id_user_provision][populate][id_users_permissions_user]=%2A&populate[id_yacht][populate][id_attendance][populate][id_provenence_list][populate][provenence]=%2A&populate[id_yacht][populate][id_attendance][populate][id_provenence_list][populate][provenence_group]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => ({
      meta: data?.meta,
      data: data?.data.map((item) => ({
        id: item?.id,
        attributes: {
          ...item?.attributes,
          note2_id: {
            note2: item?.attributes.note2,
            id: item?.id,
          },
          yacht_name_id: {
            yacht_name: item?.attributes?.id_yacht?.data?.attributes?.yacht_name,
            id: item?.attributes?.id_yacht?.data?.id,
            provenence: item?.attributes?.id_yacht?.data?.attributes?.id_attendance?.data?.[0]?.attributes?.id_provenence_list?.data?.attributes?.provenence?.data?.attributes?.provenence,
            mexal_code: item?.attributes?.id_yacht?.data?.attributes?.id_attendance?.data?.[0]?.attributes?.mexal_code,
            mexal_research_name: item?.attributes?.id_yacht?.data?.attributes?.id_attendance?.data?.[0]?.attributes?.mexal_research_name,
          },
        },
      })),
    }),
  },
  booking: {
    path: '/bookings/{{id}}?populate[id_yacht][populate][id_attendance][populate][id_agent_NA][populate][id_users_permissions_user]=%2A&populate[id_yacht][populate][id_attendance][populate][id_user_provision][populate][id_users_permissions_user]=%2A&populate[id_yacht][populate][id_attendance][populate][id_provenence_list][populate][provenence]=%2A&populate[id_reservation][populate][id_operation_list]=%2A&populate[id_marina]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => ({
      meta: data?.meta,
      data: {
        id: data?.data?.id,
        attributes: {
          ...data?.data?.attributes,
          yacht: {
            yacht_name:
              data?.data?.attributes?.id_yacht?.data?.attributes?.yacht_name,
            url_web:
              data?.data?.attributes?.id_yacht?.data?.attributes?.url_web,
            provenence:
              data?.data?.attributes?.id_yacht?.data?.attributes?.id_attendance
                ?.data?.[0]?.attributes?.id_provenence_list?.data?.attributes
                ?.provenence?.data?.attributes?.provenence,
            id: data?.data?.attributes?.id_yacht?.data?.id,
          },
        },
      },
    }),
  },
  update: {
    path: '/bookings/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        id_yacht: body?.id_yacht?.id,
        id_agent_NA: body?.id_agent_NA?.id,
        booking_status: body?.booking_status?.label,
        id_marina: body?.id_marina?.id,
        check_in_date: dayjs(body?.check_in_date).utc(),
        check_out_date: dayjs(body?.check_out_date).utc(),
      },
    }),
  },
  delete: {
    path: '/bookings/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },
  create: {
    path: '/bookings',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        id_yacht: body?.id_yacht?.id,
        id_agent_NA: body?.id_agent_NA?.id,
        booking_status: body?.booking_status?.label,
        id_marina: body?.id_marina?.id,
        check_in_date: dayjs(body?.check_in_date).utc(),
        check_out_date: dayjs(body?.check_out_date).utc(),
      },
    }),
  },
  updateFromList: {
    path: '/bookings/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
      },
    }),
  },
};
